// @ts-nocheck
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { GetProductByPathApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { CatalogPageModel, ProductModel } from "@insite/client-framework/Types/ApiModels";

const catalogPagesUrl = "/api/v1/catalogpages";
const productsUrl = "/api/v2/products";

export async function getProductByPath(parameter: GetProductByPathApiV2Parameter) {
    const result = await get<CatalogPageModel>(`${catalogPagesUrl}`, { path: parameter.path } as ApiParameter).catch(
        error => undefined,
    );
    /* Greif Custom Code - Start */
    if (!result) {
        return {
            allowZeroPricing: false,
            brand: null,
            canAddToCart: false,
            canAddToWishlist: false,
            canConfigure: false,
            canonicalUrl: "",
            canShowPrice: false,
            canShowUnitOfMeasure: false,
            configurationType: "",
            customerProductNumber: "",
            customerUnitOfMeasure: "",
            id: parameter.path,
            imageAltText: "",
            isDiscontinued: false,
            isSponsored: false,
            isVariantParent: false,
            largeImagePath: "",
            manufacturerItem: "",
            mediumImagePath: "",
            minimumOrderQty: 0,
            packDescription: "",
            priceFacet: null,
            productLine: null,
            productNumber: "",
            productTitle: "",
            quoteRequired: false,
            score: 0,
            smallImagePath: "",
            trackInventory: false,
            unitListPrice: 0,
            unitListPriceDisplay: "",
            unitOfMeasures: null,
            urlSegment: "",
            variantTypeId: null,
            defaultChildProductId: null,
            salePriceLabel: "",
            cantBuy: false,
        } as ProductModel;
    }
    /* Greif Custom Code - End */
    const productModel = await get<ProductModel>(`${productsUrl}/${result.productId}`, {
        expand: parameter.expand,
        additionalExpands: parameter.additionalExpands,
        includeAttributes: parameter.includeAttributes,
        addToRecentlyViewed: parameter.addToRecentlyViewed,
        categoryId: result.category?.id,
    } as ApiParameter);

    return productModel;
}
